/**
 * The campaign tail every CTA on a variant carries to the start flow, and
 * that the start flow keeps on its own URL: ?variant=<name> plus any utm_*
 * already on the page, so analytics can read which landing the sign-up came
 * from. Nothing else from the query string travels.
 */

export function campaignSearch(search: string, variant?: string | null): string {
  const src = new URLSearchParams(search);
  const out = new URLSearchParams();
  const name = variant ?? src.get('variant');
  if (name) out.set('variant', name);
  src.forEach((value, key) => {
    if (key.startsWith('utm_')) out.set(key, value);
  });
  const tail = out.toString();
  return tail ? `?${tail}` : '';
}
